window.__ENVIRONMENT__ = '${ENVIRONMENT}';
window.__ENV__ = '${ENV}';
window.__PUBLIC_URL__ = '${PUBLIC_URL:-https://www.qa.openbank.es/}';
window.__PRIVATE_URL__ = '${PRIVATE_URL:-https://clientes.qa.openbank.es/}';
window.__ONB_URL__ = '${ONB_URL:-https://www.qa.openbank.es/hazte-cliente/}';
window.__COUNTRY__ = '${COUNTRY:-es}';
window.__ORIGIN_COUNTRY__ = '${OK_COUNTRY}';
window.__STATIC_PREFIX_ONBOARDING__ = '${STATIC_PREFIX:-/hazte-cliente}';
window.__GOOGLE_RECAPTCHA_SITEKEY__ = '${GOOGLE_RECAPTCHA_SITEKEY}';
window.__HCAPTCHA_SITEKEY__ = '${HCAPTCHA_SITEKEY}';
window.__HCAPTCHA_LOGIN_SITEKEY__ = '${HCAPTCHA_LOGIN_SITEKEY}';
